import React from 'react'
import { Accordion, DropdownItem, Separator } from '@mc/design-system'
import Nav from '@mc/navigation'
import type { Product, ProductType } from '../../types'
import { PromoMenuItem } from '../PromoMenuItem'

export const AccordionMenu = ({
  products,
  defaultExpandedProduct,
  productSectionClassName,
}: {
  products: Product[]
  defaultExpandedProduct?: ProductType
  productSectionClassName?: string
}) => (
  <Accordion
    preExpanded={
      defaultExpandedProduct !== undefined
        ? [`item-${defaultExpandedProduct}`]
        : []
    }
  >
    {products.map((product) => (
      <Accordion.Item
        key={product.title}
        uuid={`item-${product.type}`}
        className='mc-bg-transparent mc-bg-hover-transparent'
        label={
          <div className='d-flex align-items-center flex-gap-3'>
            <h3>{product.title}</h3>
            {product.badge /* mccerts-2851_v1_core_nav_promo_signal */}
          </div>
        }
        onClick={product.onClick}
      >
        <div className={`mc-corners--md ${productSectionClassName}`}>
          {product.links.map((link) =>
            !link.href ? (
              <DropdownItem
                className='c-p-4'
                key={link.title}
                onClick={(e) => {
                  e.stopPropagation()
                  link.onClick?.()
                }}
              >
                {link.badge ? (
                  <span className='d-flex align-items-center flex-gap-3'>
                    {link.title}
                    {link.badge /* mccerts-2851_v1_core_nav_promo_signal */}
                  </span>
                ) : (
                  link.title
                )}
              </DropdownItem>
            ) : (
              <Nav.MenuLink
                key={link.title}
                href={link.href}
                onClick={(e) => {
                  e.stopPropagation()
                  link.onClick?.()
                }}
              >
                {link.promo ? <PromoMenuItem label={link.title} /> : link.title}
              </Nav.MenuLink>
            ),
          )}
          {product.separator && (
            <Separator
              // `--spacing-scale-4` is a global token, so the inset applies in
              // both the core and certificates menus; the `c-*` utility class
              // only exists when the cert stylesheet is loaded (cert pages).
              style={{
                margin: 'var(--spacing-scale-4)',
                backgroundColor: 'var(--mc-color-neutral-700)',
              }}
            />
          )}
          {product.callout}
        </div>
      </Accordion.Item>
    ))}
  </Accordion>
)
